import { useState, useMemo, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Text,
  Modal,
  TextInput,
} from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import AppBreadcrumb from "components/AppBreadcrumb";
import { showSuccessToast, showErrorToast } from "utilities/Toast";
import { delivery_time_api } from "./deliverytime.service";

export default function DeliveryTimeVariant() {
  const [opened, setOpened] = useState(false);
  const [timevarient, setTimevarient] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch list on load
  const loadData = async () => {
    setLoading(true);
    const res = await delivery_time_api.get_list();
    if (res.success) {
      setTableData(res.data);
    } else {
      showErrorToast("Failed to load data");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Save new item
  const handleSave = async () => {
    if (!timevarient.trim()) {
      showErrorToast("Please enter delivery time");
      return;
    }

    const res = await delivery_time_api.create_variant({
      timevarient: timevarient,
    });

    if (res.success) {
      showSuccessToast("Saved successfully");
      setOpened(false);
      setTimevarient("");
      loadData();
    } else {
      showErrorToast("Failed to save");
    }
  };

  // Delete row
  const handleDelete = async (id) => {
    const res = await delivery_time_api.delete_variant(id);

    if (res.success) {
      showSuccessToast("Deleted successfully");
      loadData();
    } else {
      showErrorToast("Failed to delete");
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "id",
        size: "auto",
      },
      {
        header: "Time Variant",
        accessorKey: "timevarient",
        size: "auto",
      },
      {
        header: "Created Date",
        accessorKey: "create_date",
        size: "auto",
        Cell: ({ cell }) =>
          cell.getValue()
            ? new Date(cell.getValue()).toLocaleString()
            : "NA",
      },
      {
        header: "Action",
        accessorKey: "id",
        size: "auto",
        Cell: ({ row }) => (
          <Button
            size="xs"
            color="red"
            onClick={() => handleDelete(row.original.id)}
          >
            Delete
          </Button>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Container fluid>
        <Box p={25}>
          <Flex justify="space-between" align="end">
            <Box>
              <Text size="lg" fw={600} mb={10}>
                Delivery Time Variant
              </Text>
              <AppBreadcrumb />
            </Box>

            <Button onClick={() => setOpened(true)}>Add Variant</Button>
          </Flex>
        </Box>
      </Container>

      {/* Modal */}
      <Modal opened={opened} onClose={() => setOpened(false)} title="Add Delivery Time">
        <TextInput
          label="Delivery Time Variant"
          placeholder="Eg: 10AM - 12PM"
          value={timevarient}
          onChange={(e) => setTimevarient(e.target.value)}
        />

        <Flex justify="flex-end" mt={20}>
          <Button onClick={handleSave}>Save</Button>
        </Flex>
      </Modal>

      {/* Table */}
      <Container fluid mt={10} mb={30}>
        <Box px={25}>
          <MantineReactTable
            columns={columns}
            data={tableData}
            initialState={{ density: "xs" }}
            state={{ isLoading: loading }}
            enableStickyHeader
            enableGlobalFilter={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={false}
            mantineTableProps={{ className: "datatable" }}
            renderTopToolbarCustomActions={() => (
              <Box px={5} py={10}>
                <Text fw={600} tt="uppercase" size="sm">
                  Delivery Time List
                </Text>
              </Box>
            )}
          />
        </Box>
      </Container>
    </>
  );
}
